import React from 'react';

export default function ScheduleCard({ data }) {
  const { title, days, hours, price, color } = data;

  return (
    <div
      className="lg:w-[270px] md:w-[228px] w-full h-[120px] flex flex-col xs:w-[calc(50%-5px)]
    mb-[15px]"
    >
      <div className="bg-bg-3 h-[40px] flex items-center md:px-[20px] px-[10px]">
        <span
          className="lg:text-[16px] text-[13px] leading-[24px] text-white
        font-roboto-condensed-bold uppercase"
        >
          {title}
        </span>
      </div>

      <div
        className={`${
          color === '#E11E37' ? 'bg-bg-9 text-white' : 'bg-bg-1'
        } flex items-center h-[80px] px-[20px]`}
      >
        <div className="flex grow flex-col">
          <span className="lg:text-[16px] text-[13px] leading-[24px] font-roboto-regular">
            {days}
          </span>
          <span className="lg:text-[16px] text-[13px] leading-[24px] font-roboto-regular">
            {hours}
          </span>
        </div>
        <div className="flex grow items-center justify-end">
          <span
            className={`lg:text-[16px] text-[13px] md:leading-[32px] leading-6
            font-roboto-bold uppercase ${color === '#E11E37' ? 'text-white' : 'text-bg-9'}`}
          >
            {price}
          </span>
        </div>
      </div>
    </div>
  );
}
